import React from "react";

const BackendNavBar = () => {
  return <div className=" w-full h-24 bg-primary_color">backendNavBar</div>;
};

export default BackendNavBar;
